import { lazy } from 'react';

export const LazyVulnerableNewtAuditTrailRenderingIssueReportPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--vulnerable-newt-audit-trail-rendering-issue-report-page" */ './vulnerable-newt-audit-trail-rendering-issue-report-page'
    ),
);
